(function ($) {
    'use strict';

    function getSection($form) {
        return $form.closest('[data-find-reps]');
    }

    function setLoading($section, isLoading) {
        $section.find('.find-reps-output').toggleClass('is-loading', isLoading);
        $section.find('.find-reps-loading').toggleClass('is-active', isLoading).attr('aria-hidden', !isLoading);
    }

    function showDefaultStatus($section) {
        $section.find('.find-reps-status--default').prop('hidden', false);
        $section.find('.find-reps-status--empty').prop('hidden', true);
        $section.find('.find-reps-results').empty();
    }

    function showEmptyStatus($section) {
        $section.find('.find-reps-status--default').prop('hidden', true);
        $section.find('.find-reps-status--empty').prop('hidden', false);
        $section.find('.find-reps-results').empty();
    }

    function showResults($section, html) {
        $section.find('.find-reps-status--default').prop('hidden', true);
        $section.find('.find-reps-status--empty').prop('hidden', true);
        $section.find('.find-reps-results').html(html);
    }

    function getSelectedTypeIds($form) {
        return $form.find('.find-reps-type:checked').map(function () {
            return $(this).val();
        }).get();
    }

    function hasActiveFilters($form) {
        var location = $form.find('.find-reps-location').val();
        return Boolean(location || getSelectedTypeIds($form).length);
    }

    function fetchRepresentatives($form) {
        var $section = getSection($form);

        if (!hasActiveFilters($form)) {
            showDefaultStatus($section);
            setLoading($section, false);
            return;
        }

        setLoading($section, true);

        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'find_representatives',
                nonce: ThemeJS.Variables.Ajax.nonce,
                location: $form.find('.find-reps-location').val(),
                representative_type: getSelectedTypeIds($form),
            },
            success: function (data) {
                if (data.state === 'results' && data.html) {
                    showResults($section, data.html);
                } else if (data.state === 'empty' || !data.count) {
                    showEmptyStatus($section);
                } else {
                    showDefaultStatus($section);
                }
                setLoading($section, false);
            },
            error: function () {
                showEmptyStatus($section);
                setLoading($section, false);
            },
        });
    }

    $(function () {
        $('[data-find-reps] .find-reps-filters').each(function () {
            var $form = $(this);
            var $section = getSection($form);

            showDefaultStatus($section);

            $form.on('change', 'select, .find-reps-type', function () {
                fetchRepresentatives($form);
            });
        });
    });
})(jQuery);
